import { render } from "./PageFooter.vue?vue&type=template&id=cd8dfd80&scoped=true&ts=true"
import script from "./PageFooter.ts?vue&type=script&lang=ts"
export * from "./PageFooter.ts?vue&type=script&lang=ts"

import "./PageFooter.scss?vue&type=style&index=0&id=cd8dfd80&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd8dfd80"]])

export default __exports__